import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ENCRYPT_DUTY_FREE_PREORDER_RESULT_STORE_NAME,
  EncryptDutyFreePreorderResultState,
} from './encrypt-duty-free-preorder-result.state';

/** Select EncryptDutyFreePreorderResult State */
export const selectEncryptDutyFreePreorderResultState = createFeatureSelector<EncryptDutyFreePreorderResultState>(
  ENCRYPT_DUTY_FREE_PREORDER_RESULT_STORE_NAME
);

/** Select EncryptDutyFreePreorderResult isPending status */
export const selectEncryptDutyFreePreorderResultIsPendingStatus = createSelector(
  selectEncryptDutyFreePreorderResultState,
  (state) => !!state.isPending
);

/** Select EncryptDutyFreePreorderResult isFailure status */
export const selectEncryptDutyFreePreorderResultIsFailureStatus = createSelector(
  selectEncryptDutyFreePreorderResultState,
  (state) => !!state.isFailure
);
